import { types } from "../actions/user";

const initialState = { logging: false, haveUnsavedChanges: false };

function userReducer(state = initialState, action) {
  switch (action.type) {
    case types.USER_LOGIN_REQUEST: {
      return { logging: true };
    }
    case types.USER_LOGIN_ERROR: {
      return { ...state, errored: true, logging: false };
    }
    case types.USER_LOGGED: {
      return action.payload;
    }
    case types.USER_SELECT_TENANT: {
      return {
        ...state,
        tenant: action.payload.tenant,
        branch: action.payload.branch
      };
    }
    case types.USER_SELECT_BRANCH: {
      return {
        ...state,
        branch: action.payload
      };
    }
    case types.USER_CREATE_BRANCH: {
      return {
        ...state,
        branches: {
          ...state.branches,
          [state.tenant]: [...state.branches[state.tenant], action.payload]
        },
        branch: action.payload
      };
    }
    case types.USER_DELETE_BRANCH: {
      return {
        ...state,
        branches: {
          ...state.branches,
          [state.tenant]: state.branches[state.tenant].filter(
            (branch) => branch !== action.payload
          )
        },
        branch: "main"
      };
    }
    case types.USER_LOGGED_STATUS: {
      return { ...state, loggedStatus: action.payload };
    }
    case types.USER_LOGGED_USERS: {
      return { ...state, loggedUsers: action.payload };
    }
    case types.USER_LOGOUT: {
      return initialState;
    }

    default:
      return state;
  }
}

export default userReducer;
